import { useState } from "react";
import { storyVolumes } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function StoryArc() {
  const [activeId, setActiveId] = useState(storyVolumes[0].id);
  const active = storyVolumes.find((vol) => vol.id === activeId) ?? storyVolumes[0];

  return (
    <section id="story" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Story Arc"
          title="剧情脉络：按卷切换查看章节"
          desc="整部作品目前分为四卷，从搬回老城到重新出发逐层推进。点击下方卷册即可切换查看该卷的简介与代表章节摘要。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {storyVolumes.map((vol) => {
            const isActive = vol.id === activeId;
            return (
              <button
                key={vol.id}
                type="button"
                onClick={() => setActiveId(vol.id)}
                aria-pressed={isActive}
                className={`px-4 py-2.5 rounded-md text-sm whitespace-nowrap cursor-pointer border transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {vol.name}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <aside className="lg:col-span-4 p-5 md:p-6 rounded-lg bg-secondary-50 border border-secondary-200">
            <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap">
              <i className="ri-bookmark-3-line" />
              {active.range}
            </span>
            <h3 className="mt-3 font-heading text-xl font-semibold text-foreground-950">{active.name}</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{active.intro}</p>
            <div className="mt-5 pt-4 border-t border-secondary-200 flex items-center justify-between text-xs text-foreground-500">
              <span>状态</span>
              <span className="font-medium text-secondary-700">{active.status}</span>
            </div>
            <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
              <span>代表章节</span>
              <span className="font-medium text-secondary-700">{active.chapters.length} 段摘要</span>
            </div>
          </aside>

          <div className="lg:col-span-8 flex flex-col gap-4">
            {active.chapters.map((chapter, index) => (
              <article
                key={chapter.no}
                className="p-5 rounded-lg bg-background-100 border border-background-200 flex gap-4"
              >
                <div className="w-11 h-11 shrink-0 rounded-md bg-accent-100 text-accent-900 flex flex-col items-center justify-center">
                  <span className="font-heading text-sm font-semibold leading-none">{String(index + 1).padStart(2, "0")}</span>
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="text-xs text-primary-700">{chapter.no}</span>
                    <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {chapter.title}
                    </h4>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{chapter.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}